module.exports = __webpack_public_path__ + "static/media/keeano-icon.03f54660.svg";